/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    type: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
};

const defaultProps = {
    ...commonDefaultProps,
};

const ListItemIcon = (props) => {
    const classNames = [
        'c-list__item-icon',
        props.type ? `c-list__item-icon--${props.type}` : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

ListItemIcon.propTypes = propTypes;

ListItemIcon.defaultProps = defaultProps;

export default ListItemIcon;
